import React, { useEffect } from 'react';
import { getSearchParams } from '@wix/package-picker-shared';
import { useAnonymous } from '../hooks';
import { useCheckoutDeepLink } from '../hooks/useCheckoutDeepLink';
import { useValidateCycle, useValidateProductId } from '../hooks/validations';
import { EclipsePackagePickerSteps } from '../types/types';
import { MOBILE_STICKY_BUTTON_SPEC } from '../utils/consts';
import { isMobileStickyPlanAndCycleEnabled } from '../utils/isMobileStickyPlanAndCycleEnabled';
import { ECLIPSE_MOBILE_MODULE_NAME } from '../utils/moduleNames';
import { useCurrentModule } from './ModuleProvider';
export const RouteGuard = _ref => {
  let {
    step,
    Element
  } = _ref;
  const module = useCurrentModule();
  const {
    setSelectedProductId,
    setSelectedCycleId
  } = module.SDK.PackagePickerStore;
  const changeRoute = module.internals.hooks.useChangeRoute();
  const {
    isAnonymous
  } = useAnonymous();
  const {
    valid: isProductIdValid,
    isLoading: isProductIdLoading
  } = useValidateProductId();
  const {
    valid: isCycleValid,
    isLoading: isCycleLoading
  } = useValidateCycle();
  const {
    isActive: isCheckoutDeepLinkActive
  } = useCheckoutDeepLink(step);
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const picksPlanBeforeLeaving = isMobileStickyPlanAndCycleEnabled({
    experiments,
    isMobile: module.moduleName === ECLIPSE_MOBILE_MODULE_NAME
  }) || experiments.isEnabled(MOBILE_STICKY_BUTTON_SPEC);
  const backToSelectPlan = () => {
    setSelectedProductId(null);
    setSelectedCycleId(null);
    changeRoute(EclipsePackagePickerSteps.SELECT_PLAN);
  };
  useEffect(() => {
    const {
      productId,
      cycleId
    } = getSearchParams();
    if (step === EclipsePackagePickerSteps.ANY) {
      changeRoute(EclipsePackagePickerSteps.SELECT_PLAN);
      return;
    }
    if (step === EclipsePackagePickerSteps.EMPTY) {
      if (!isAnonymous) {
        changeRoute(EclipsePackagePickerSteps.SELECT_PLAN);
      }
      return;
    }
    if (step === EclipsePackagePickerSteps.SELECT_PLAN) {
      if (isCheckoutDeepLinkActive) {
        return;
      }
      if (!picksPlanBeforeLeaving) {
        setSelectedProductId(null);
      }
      setSelectedCycleId(null);
      return;
    }
    if (step === EclipsePackagePickerSteps.SELECT_CYCLE) {
      setSelectedCycleId(null);
      if (!isProductIdLoading && !isProductIdValid) {
        backToSelectPlan();
        return;
      }
    }
    if (step === EclipsePackagePickerSteps.CHECKOUT) {
      if (isAnonymous) {
        backToSelectPlan();
        return;
      }
      if (!isProductIdLoading && !isProductIdValid) {
        backToSelectPlan();
        return;
      }
      if (!isCycleLoading && !isCycleValid) {
        setSelectedCycleId(null);
        changeRoute(EclipsePackagePickerSteps.SELECT_CYCLE);
        return;
      }
    }
    setSelectedProductId(productId ?? null);
    setSelectedCycleId(cycleId ?? null);
  }, [isAnonymous, step, isProductIdValid, isCycleValid, isProductIdLoading, isCycleLoading, isCheckoutDeepLinkActive, picksPlanBeforeLeaving]);
  return /*#__PURE__*/React.createElement(Element, null);
};
//# sourceMappingURL=RouteGuard.js.map